import React, { createContext, useState, useContext, useEffect } from 'react'

const ThemeContext = createContext()

export const useTheme = () => {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider')
  }
  return context
}

export const ThemeProvider = ({ children }) => {
  // Mode fosc per defecte (true = mode fosc)
  const [isDarkMode, setIsDarkMode] = useState(true)

  // Aplicar el tema inicial en carregar
  useEffect(() => {
    document.documentElement.style.setProperty('--background-color', '#1a1a1a')
    document.documentElement.style.setProperty('--text-color', '#ffffff')
  }, [])

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode)
    // Aplicar el tema l'element arrel (html)
    document.documentElement.style.setProperty('--background-color', !isDarkMode ? '#1a1a1a' : '#ffffff')
    document.documentElement.style.setProperty('--text-color', !isDarkMode ? '#ffffff' : '#000000')
  }

  return <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>{children}</ThemeContext.Provider>
}
